import instObj from '@/backend/axios-instances'

const resource = "/status"
const instance = instObj.baseInstance

export default {
  sync(parameters) {
    return instance.get(resource, { params: parameters });
  }
}